import createSharingDataFromAttachments from './createSharingDataFromAttachments';
import { SharingData } from 'owa-sharing-data';
import AttachmentWellViewState from '../../schema/AttachmentWellViewState';

// TODO: 32525 This is a satchel V3 selector, and should be put in a selectors folder when moved to owa-sharing-data
export function getSucceesfulSharingDataFromAttachments(
    viewState: AttachmentWellViewState
): SharingData[] {
    const attachments = viewState.docViewAttachments.concat(viewState.imageViewAttachments);
    return createSharingDataFromAttachments(attachments).filter(
        data => data.sharingInfo && data.sharingInfo.getSharingInfoSucceeded
    );
}
